import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramPharmaciesPage } from './program-pharmacies';
import { MatButtonModule, MatTableModule, MatFormFieldModule, MatInputModule, MatSortModule, MatPaginatorModule, MatIconModule } from '@angular/material';

@NgModule({
  declarations: [
    ProgramPharmaciesPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramPharmaciesPage),
    MatButtonModule, MatTableModule, MatFormFieldModule, MatInputModule, MatSortModule, MatPaginatorModule, MatIconModule
  ],
})
export class ProgramPharmaciesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-pharmacies/program-pharmacies.module.ts